export enum NodeHandlerId {
    SOURCE_TOP = 'source-top',
    SOURCE_RIGHT = 'source-right',
    SOURCE_BOTTOM = 'source-bottom',
    SOURCE_LEFT = 'source-left',
    TARGET_TOP = 'target-top',
    TARGET_RIGHT = 'target-right',
    TARGET_BOTTOM = 'target-bottom',
    TARGET_LEFT = 'target-left',
}
